import { FC, useState, useRef, useEffect, CSSProperties } from 'react';
import { NewBaseIcon } from '@shared/components/base/NewBaseIcon';

import styles from './index.module.less';
import { heart_fill, heart } from './svg';


type BitParamter = {
	x: number;
	y: number;
	size: number;
	time: number;
};

function randomInt(min: number, max: number) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

export const Heart: FC<{
	color?: string;
	isLiked: boolean;
	size?: number;
	time?: number;
  // 新增的 SVG 图标属性
	iconDefault?: string; 
  iconLiked?: string; 
	iconParticle?: string;   
}> = ({ 
	isLiked, size = 16, color, time = 600,
	iconDefault = heart,      
  iconLiked = heart_fill,  
	iconParticle,
}) => {
	const [bit, setBit] = useState<BitParamter[]>([]);
	const timer = useRef<any>();
	const IconRealSize = size / 16;
	const particleIcon = iconParticle || iconLiked;
	const playAnimation = () => {
		setBit(
			new Array(randomInt(2, 4)).fill(0).map(() => {
				const radius = Math.random() * 8 + 20;
				// 从右开始顺时针计算，让他向上1/3个圆发射,不然下面会被overflow遮挡
				const deg = -Math.PI / 2 + ((Math.random() - 0.5) * Math.PI * 2) / 3;
				return {
					x: Math.cos(deg) * radius * IconRealSize,
					y: Math.sin(deg) * radius * IconRealSize,
					size: randomInt(8, 16) * IconRealSize,
					time: (Math.random() + 0.5) * time,
				};
			}),
		);
		timer.current = setTimeout(() => {
			setBit([]);
			timer.current = null;
		}, time * 1.5);
	};
	useEffect(() => {
		if (isLiked && timer.current !== undefined) playAnimation();
		else {
			setBit([]);
			if (timer.current) clearTimeout(timer.current);
			timer.current = null;
		}
	}, [isLiked]);
	return (
		<div style={{ position: 'relative', '--full-size': size + 'px' } as CSSProperties}>
			<NewBaseIcon
				className={isLiked ? styles['like-button'] : styles.dislike}
				icon={isLiked ? iconLiked : iconDefault}
				size={size}
				color={color}
			/>
			{bit.map((i, x) => (
				<NewBaseIcon
					key={x}
					icon={particleIcon}
					className={styles['ani-g']}
					size={i.size}
					style={
						{
							'--x': i.x + 'px',
							'--y': i.y + 'px',
							'--size': i.size + 'px',
							'--time': i.time + 'ms',
						} as CSSProperties
					}
				/>
			))}
		</div>
	);
};
